import { render, staticRenderFns } from "./EvergreenQueue.vue?vue&type=template&id=9006af20&"
import script from "./EvergreenQueue.vue?vue&type=script&lang=js&"
export * from "./EvergreenQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports